export default "#define SHADER_NAME line-layer-fragment-shader\n\nprecision highp float;\n\nvarying vec4 vColor;\nvarying vec2 uv;\n\nvoid main(void) {\n  geometry.uv = uv;\n\n  gl_FragColor = vColor;\n\n  DECKGL_FILTER_COLOR(gl_FragColor, geometry);\n}\n";
//# sourceMappingURL=line-layer-fragment.glsl.js.map


// WEBPACK FOOTER //
// ./~/@deck.gl/layers/dist/esm/line-layer/line-layer-fragment.glsl.js